var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminView',[_c('h1',{staticClass:"title-1"},[_vm._v("Rangs")]),_c('div',{staticClass:"column"},[_c('RankForm',{attrs:{"ranks":_vm.ranks}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }